__webpack_require__.p = "https://static.znanierussia.ru/production/_next/";